export * from './slide-toggle';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/slide-toggle/index.js
// module id = 459
// module chunks = 8